import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { useHandleCardCreation } from '@package/smart-wallet';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

/* Schemas */
export const CardCreationFormSchema = z.object({
  holderId: z.string().refine((value) => !value || !isNaN(Number(value)), {
    message: 'Holder Id must be a valid number',
  }),
  tierId: z.string().refine((value) => !value || !isNaN(Number(value)), {
    message: 'Tier Id must be a valid number',
  }),
});

/* Types */
export type CardCreationFormType = z.infer<typeof CardCreationFormSchema>;

/* Components */
export const CardCreation = () => {
  const {
    handleCardCreation: handleCardCreationCallback,
    isLoading: isLoadingCardCreation,
  } = useHandleCardCreation();

  /* Form */
  const depositForm = useForm<CardCreationFormType>({
    resolver: zodResolver(CardCreationFormSchema),
  });

  /* Handlers */
  const handleCardCreation = async (data: CardCreationFormType) => {
    try {
      const txHash = await handleCardCreationCallback(
        Number(data.holderId),
        Number(data.tierId),
      );

      console.log('=== txHash ===', txHash);
    } catch (error) {
      console.error('Error creating card: ', error);
    }
  };

  /* Render */
  return (
    <section className='w-2/3 flex flex-col items-center justify-center gap-4'>
      <Form {...depositForm}>
        <form
          onSubmit={depositForm.handleSubmit(handleCardCreation)}
          className='w-full flex flex-col items-center justify-center gap-4'
        >
          <section className='w-full flex flex-row items-center justify-center gap-4'>
            <FormField
              control={depositForm.control}
              name='holderId'
              render={({ field }) => (
                <FormItem className='w-full'>
                  <FormLabel>Holder Id</FormLabel>
                  <FormControl>
                    <Input placeholder='1' type='number' {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={depositForm.control}
              name='tierId'
              render={({ field }) => (
                <FormItem className='w-full'>
                  <FormLabel>Tier Id</FormLabel>
                  <FormControl>
                    <Input placeholder='1' type='number' {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </section>
          <Button
            type='submit'
            className='cursor-pointer w-full'
            disabled={isLoadingCardCreation}
          >
            {isLoadingCardCreation ? 'Creating card...' : 'Create card'}
          </Button>
        </form>
      </Form>
    </section>
  );
};
